import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.096 5.175a.143.143 0 0 0-.143-.143l-1.178.006L8 7.154 6.227 5.039l-1.18-.005a.142.142 0 0 0-.144.143c0 .034.013.066.034.093L7.26 8.038l-2.323 2.766a.143.143 0 0 0 .109.236l1.18-.006L8 8.918l1.773 2.114 1.178.006a.142.142 0 0 0 .143-.143.149.149 0 0 0-.034-.093L8.74 8.036l2.324-2.768a.143.143 0 0 0 .032-.093Z",
      fill: "#8F8F8F"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8 0a8 8 0 1 0 .001 16.001A8 8 0 0 0 8 0Zm0 14.643A6.644 6.644 0 0 1 8 1.357a6.644 6.644 0 0 1 0 13.286Z",
      fill: "#8F8F8F"
    }, null, -1)
  ]))]))
}
export default { render: render }